import { render } from "./BlogRightSidebarPage.vue?vue&type=template&id=2f3c699d&ts=true"
import script from "./BlogRightSidebarPage.vue?vue&type=script&lang=ts"
export * from "./BlogRightSidebarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__